export enum PlatformType {
    DINEMARKET = '2a812ad1-8fcb-47a4-98e0-9776dda4d5e1',
    AMAST = 'c0629882-e7d8-4f0d-b966-99b3f04d0d7f',
    ACADIA_MARKET = 'fa160249-83f4-4a60-98dd-b8458e89d9a4',
    LM = 'ap160249-83f4-4a60-98dd-b8458e89d9t9'
}
